// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"_1c127d"};